const S = /^\d{4}-\d{2}-\d{2}(T\d{2}:\d{2}:\d{2}(\.\d{1,3})?(Z|[+-]\d{2}:?\d{2})?)?$/, u = (e) => {
  if (!S.test(e))
    return !1;
  const r = new Date(e);
  if (isNaN(r.getTime()))
    return !1;
  if (!e.includes("T") || e.endsWith("Z")) {
    const c = r.toISOString(), d = e.split("T")[0];
    return d ? c.startsWith(d) : !1;
  }
  return !0;
}, g = (e, r) => a(e, r, 0), a = (e, r, c = 0) => {
  const d = (r == null ? void 0 : r.deep) ?? !1, y = (r == null ? void 0 : r.deepArrays) ?? !1, i = (r == null ? void 0 : r.maxDepth) ?? 50;
  if (c >= i)
    throw new Error(
      `Maximum recursion depth of ${i} exceeded in parseISOStrings. This may indicate circular references or deeply nested data structures.`
    );
  const f = r == null ? void 0 : r.predicate;
  if (typeof e == "string")
    return u(e) ? f && !f(e) ? e : new Date(e) : e;
  if (e == null)
    return e;
  if (Array.isArray(e))
    return e.map((t) => typeof t == "string" && u(t) ? f && !f(t) ? t : new Date(t) : y && (typeof t == "object" || Array.isArray(t)) ? a(t, r, c + 1) : t);
  if (e instanceof Date)
    return e;
  if (typeof e == "object" && e !== null) {
    const t = {};
    for (const s in e) {
      const n = e[s];
      f && !f(n, s, e) ? t[s] = n : typeof n == "string" && u(n) ? t[s] = new Date(n) : d && typeof n == "object" && n !== null ? t[s] = a(n, r, c + 1) : t[s] = n;
    }
    return t;
  }
  return e;
};
export {
  u as isISOString,
  g as parseISOStrings
};
//# sourceMappingURL=index.es.js.map
